import { ESynupListingsReviewsProviders } from '@models/organization/synupListingsReviewsProviders.enum';

interface IFindOneOutsetaPlanResponseFamily {
  id: string;
  name: string;
  active: boolean;
}

interface IFindOneOutsetaPlanResponsePlanAddon {
  id: string;
  selectable: boolean;
}

export interface IFindOneOutsetaPlanResponse {
  data: {
    id: string;
    name: string;
    description: string | null;
    minimumQuantity: number;
    quantityEditable: boolean;
    monthlyRate: number;
    annualRate: number;
    active: boolean;
    trialPeriodDays: number;
    family: IFindOneOutsetaPlanResponseFamily;
    planAddons: IFindOneOutsetaPlanResponsePlanAddon[];
  };
  message: string;
}
export interface IFindOneMembershipPackagesResponse {
  name: string;
  country: string;
  outsetaUids: IFindOneMembershipPackagesResponseOutsetaUids[];
  features: IFindOneMembershipPackagesResponseFeature[];
  quantity?: number;
}

export interface IFindOneMembershipPackagesResponseOutsetaUids {
  outsetaUid: string;
  outsetaRealmUrl: string;
}

export interface IFindOneMembershipPackagesResponseFeature {
  name: string;
  domain: EPolicyDomain;
  usageLimit?: number;
  renewal?: string;
  synupProviders?: IFindOneMembershipPackagesResponseSynupProvider[];
}

export interface IFindOneMembershipPackagesResponseSynupProvider {
  name: ESynupListingsReviewsProviders;
  synupId: number;
  isListingProvider: boolean;
  isReviewsProvider: boolean;
}

export interface IPasswordResetResponse {
  data: null;
}

export interface IFindCancellationReasonsResponse {
  data: {
    cancellationReasons: string[];
  };
  message: string;
}

export enum EPolicyNames {
  LISTING_BASIC = 'LISTING_BASIC',
  LISTING_PRO = 'LISTING_PRO',
  LISTING_START = 'LISTING_START',
  LISTING_ESSENTIAL = 'LISTING_ESSENTIAL',
  LISTING_MAX = 'LISTING_MAX',
  REPUTATION_BASIC = 'REPUTATION_BASIC',
  REPUTATION_PRO = 'REPUTATION_PRO',
  REPUTATION_AUTOPILOT = 'REPUTATION_AUTOPILOT',
  JOOICE_AI_BASIC_IMAGE_GENERATION = 'JOOICE_AI_BASIC_IMAGE_GENERATION',
  JOOICE_AI_BASIC_TEXT_GENERATION = 'JOOICE_AI_BASIC_TEXT_GENERATION',
  JOOICE_AI_PRO_IMAGE_GENERATION = 'JOOICE_AI_PRO_IMAGE_GENERATION',
  JOOICE_AI_PRO_TEXT_GENERATION = 'JOOICE_AI_PRO_TEXT_GENERATION',
  SOCIAL_PRO = 'SOCIAL_PRO',
  SOCIAL_BASIC = 'SOCIAL_BASIC',
  SOCIAL_START = 'SOCIAL_START',
  SOCIAL_NETWORKS = 'SOCIAL_NETWORKS',
}

export enum EPolicyDomain {
  LISTINGS = 'LISTINGS',
  INTERACTIONS = 'INTERACTIONS',
  JOOICE_AI = 'JOOICE_AI',
  SOCIAL = 'SOCIAL',
  BUNDLE = 'BUNDLE',
}
